import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementVNode as _createElementVNode, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "epl"
}
const _hoisted_2 = {
  key: 0,
  class: "epl-status"
}
const _hoisted_3 = {
  key: 0,
  class: "epl-error"
}
const _hoisted_4 = {
  key: 1,
  class: "epl-status"
}
const _hoisted_5 = {
  key: 0,
  class: "epl-role"
}
const _hoisted_6 = { class: "epl-label" }
const _hoisted_7 = { class: "epl-options" }
const _hoisted_8 = ["aria-pressed", "onClick"]
const _hoisted_9 = { class: "epl-val" }
const _hoisted_10 = ["aria-pressed", "onClick"]
const _hoisted_11 = { class: "epl-val" }
const _hoisted_12 = {
  key: 0,
  class: "epl-hint"
}
const _hoisted_13 = { class: "epl-actions" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["disabled", "onClick"]
const _hoisted_17 = {
  key: 0,
  class: "epl-error"
}

import { computed, reactive, ref, watch } from 'vue'
import { employeeApi } from '@/services/api'

type Side = 'app' | 'web'

interface Field {
  key: string
  label: string
  appValue: string
  webValue: string
  hint?: string
}

interface LinkItem {
  role: string
  roleLabel?: string
  centerName?: string
  mCode: string
  clciIdx: number
  clciSource: string
  conflicts: Field[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeProfileLinkPanel',
  props: {
    mCode: {},
    source: {},
    clciIdx: {}
  },
  emits: ["applied"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const loading = ref(false)
const saving = ref(false)
const linked = ref(false)
const links = ref<LinkItem[]>([])
const warnings = ref<string[]>([])
const errorText = ref('')
const choices = reactive<Record<string, Side>>({})

const visible = computed(() => !!props.mCode && !!props.clciIdx && (props.source === 'auto' || props.source === 'manual'))

const linkKey = (link: LinkItem) => `${link.role}:${link.clciSource}:${link.clciIdx}`
const fieldKey = (link: LinkItem, key: string) => `${linkKey(link)}:${key}`
const choiceOf = (link: LinkItem, key: string) => choices[fieldKey(link, key)] || ''

const ready = (link: LinkItem) =>
  link.conflicts.every((field) => choiceOf(link, field.key) === 'app' || choiceOf(link, field.key) === 'web')

const pick = (link: LinkItem, key: string, side: Side) => {
  choices[fieldKey(link, key)] = side
  errorText.value = ''
}

const pickLink = (link: LinkItem, side: Side) => {
  link.conflicts.forEach((field) => {
    choices[fieldKey(link, field.key)] = side
  })
}

const applyPayload = (data: any) => {
  linked.value = data?.linked === true
  links.value = Array.isArray(data?.links) ? data.links : []
  warnings.value = Array.isArray(data?.warnings) ? data.warnings : []
  const alive = new Set<string>()
  links.value.forEach((link) => {
    ;(link.conflicts || []).forEach((field) => alive.add(fieldKey(link, field.key)))
  })
  Object.keys(choices).forEach((key) => {
    if (!alive.has(key)) delete choices[key]
  })
}

const load = async () => {
  if (!visible.value) return
  loading.value = true
  errorText.value = ''
  try {
    const res = await employeeApi.getProfileLink(
      props.mCode,
      props.source === 'manual' ? 'manual' : 'auto',
      props.clciIdx
    )
    applyPayload(res.data?.data)
    if (res.data?.data?.filledCount) emit('applied')
  } catch (error: any) {
    links.value = []
    linked.value = false
    errorText.value = error.response?.data?.message || error.message || '회원정보를 대조하지 못했습니다.'
  } finally {
    loading.value = false
  }
}

const save = async (link: LinkItem) => {
  if (!ready(link) || saving.value) return
  saving.value = true
  errorText.value = ''
  try {
    const choicesBody = Object.fromEntries(link.conflicts.map((field) => [field.key, choiceOf(link, field.key)]))
    const res = await employeeApi.applyProfileLink(
      props.mCode,
      props.source === 'manual' ? 'manual' : 'auto',
      props.clciIdx,
      { role: link.role, choices: choicesBody }
    )
    applyPayload(res.data?.data)
    emit('applied')
  } catch (error: any) {
    errorText.value = error.response?.data?.message || error.message || '저장하지 못했습니다.'
  } finally {
    saving.value = false
  }
}

watch(
  () => `${props.mCode}:${props.source}:${props.clciIdx}`,
  () => {
    links.value = []
    warnings.value = []
    void load()
  },
  { immediate: true }
)

return (_ctx: any,_cache: any) => {
  return (visible.value)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, "앱 회원정보와 대조하는 중..."))
          : (!linked.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (errorText.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(errorText.value), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_4, "연결된 앱 회원이 없습니다."))
              ], 64))
            : (!links.value.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _cache[0] || (_cache[0] = _createElementVNode("p", { class: "epl-ok" }, "앱에 입력한 정보와 직원정보가 같은 항목은 맞춰져 있습니다.", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(warnings.value, (warn, i) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: i,
                      class: "epl-warn"
                    }, _toDisplayString(warn), 1))
                  }), 128))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _cache[3] || (_cache[3] = _createElementVNode("header", { class: "epl-head" }, [
                    _createElementVNode("h4", { class: "epl-title" }, "앱 회원정보와 다른 항목"),
                    _createElementVNode("p", { class: "epl-lead" }, " 같은 항목인데 내용이 다릅니다. 웹과 앱에 함께 쓸 값을 골라 주세요. 같은 값은 그대로 두었고, 한쪽만 있는 값은 채워 두었습니다. ")
                  ], -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(warnings.value, (warn, i) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: `w-${i}`,
                      class: "epl-warn"
                    }, _toDisplayString(warn), 1))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(links.value, (link) => {
                    return (_openBlock(), _createElementBlock("article", {
                      key: linkKey(link),
                      class: "epl-block"
                    }, [
                      (links.value.length > 1)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(link.roleLabel || '앱 회원'), 1))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(link.conflicts, (field) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: field.key,
                          class: "epl-field"
                        }, [
                          _createElementVNode("p", _hoisted_6, _toDisplayString(field.label), 1),
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["epl-option", { 'is-on': choiceOf(link, field.key) === 'app' }]),
                              "aria-pressed": choiceOf(link, field.key) === 'app',
                              onClick: ($event: any) => (pick(link, field.key, 'app'))
                            }, [
                              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "epl-who" }, "앱에서 입력", -1)),
                              _createElementVNode("span", _hoisted_9, _toDisplayString(field.appValue), 1)
                            ], 10, _hoisted_8),
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["epl-option", { 'is-on': choiceOf(link, field.key) === 'web' }]),
                              "aria-pressed": choiceOf(link, field.key) === 'web',
                              onClick: ($event: any) => (pick(link, field.key, 'web'))
                            }, [
                              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "epl-who" }, "직원정보에 등록", -1)),
                              _createElementVNode("span", _hoisted_11, _toDisplayString(field.webValue), 1)
                            ], 10, _hoisted_10)
                          ]),
                          (field.hint)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(field.hint), 1))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "epl-text",
                          onClick: ($event: any) => (pickLink(link, 'app'))
                        }, "이 회원은 모두 앱 정보", 8, _hoisted_14),
                        _createElementVNode("button", {
                          type: "button",
                          class: "epl-text",
                          onClick: ($event: any) => (pickLink(link, 'web'))
                        }, "이 회원은 모두 직원정보", 8, _hoisted_15),
                        _createElementVNode("button", {
                          type: "button",
                          class: "epl-save",
                          disabled: !ready(link) || saving.value,
                          onClick: ($event: any) => (save(link))
                        }, _toDisplayString(saving.value ? '저장 중...' : '이 정보로 맞추기'), 9, _hoisted_16)
                      ])
                    ]))
                  }), 128)),
                  (errorText.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(errorText.value), 1))
                    : _createCommentVNode("", true)
                ], 64))
      ]))
    : _createCommentVNode("", true)
}
}

})